<section class="schedule-email-container">
  <div>
    <span class="label col-4">Send To:</span>
    <div class="field">
      <mat-chip-listbox aria-label="sending to" class="w-100">
        <mat-chip *ngFor="let tag of tagList">
          {{tag}}
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </div>
  <div>
    <button mat-button color="primary"  
      [matTooltip]="recipientList | tooltipList: 'email'"
      [matTooltipClass]="'tooltip-list'"
      aria-label="list of recipients">
      {{recipientList.length}} Recipients total
    </button>
  </div>
  <div>
    <span class="label col-4">Date & Time :</span>
    <div class="field">
      <mat-form-field>
        <input matInput [ngxMatDatetimePicker]="dateTimePicker" [(ngModel)]="scheduleDateTime"
          [min]="minDate" [disabled]="isNowSelected" (ngModelChange)="onDateTimeChange()">
        <mat-datepicker-toggle matSuffix [for]="dateTimePicker"
          style="vertical-align: super;"></mat-datepicker-toggle>
        <ngx-mat-datetime-picker #dateTimePicker></ngx-mat-datetime-picker>
      </mat-form-field>
    </div>
  </div>
  <div>
    <span class="label col-4">Repeat:</span>
    <div class="field">
      <mat-button-toggle-group [(ngModel)]="frequency" aria-label="frequency" (change)="onFrequencyChange($event.value)">
        <mat-button-toggle *ngIf="!isEditMode" [value]="Frequency.Now">Now</mat-button-toggle>
        <mat-button-toggle [value]="Frequency.OneTime">One Time</mat-button-toggle>
        <mat-button-toggle [value]="Frequency.Daily">Daily</mat-button-toggle>
        <mat-button-toggle [value]="Frequency.Weekly">Weekly</mat-button-toggle>
        <mat-button-toggle [value]="Frequency.Monthly">Monthly</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
  <div>
    <span class="label col-4">Timezone:</span>
    <div class="field">
      <app-autocomplete-search
            label="Timezone"
            [options]="timezones"
            [(ngModel)]="selectedTimezone"
            [disabled]="isNowSelected"
            (ngModelChange)="onTimezoneChange()"
      ></app-autocomplete-search>
    </div>
  </div>  
</section>